import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import colorConstants from '../../constants/colorConstants';
const processNodeStyles = makeStyles((theme: Theme) =>
  createStyles({
    processNode: {
      minWidth: '50px',
      maxWidth: '190px',
      fontSize: '0.8rem',
      border: '1px solid #000',
      padding: '5px',
      borderRadius: '5px',
      background: 'white',
      textAlign: 'center',
      wordBreak: 'break-word',
    },
    text: {
      // marginTop: '16px',
    },
    errorNode: {
      background: colorConstants.ERROR_NODE,
    },
    successNode: {
      background: colorConstants.SELECTED_COLOR,
    },
    warningNode: {
      background: colorConstants.WARNING_COLOR,
    },
    searched: {
      background: colorConstants.CURRENTJOURNEY_ORCHSTEP_COLOR,
    },
    selected: {
      background: colorConstants.SELECTED_COLOR,
    },
  }),
);

export { processNodeStyles };
